<template>
  <div class="cars">
    <div class="approve-box text-c">
      <img class="approve" :src="img.approve">
      <div class="f-16 f-w">您的认证已提交，审核时间2-3个工作日完成</div>
    </div>
    <!-- <div class="f-12 c-gray mt-25 text-c">恭喜您获得以下好礼！</div>
    <div class="mt-25">
      <div class="gift_box">
        <div class="f-12 gift_title">XXX积分 1000</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">雷克萨斯镂空机械腕表-男士 1枚</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">勋章：XXX1</div>
        <div class="getBtn">领取</div>
      </div>
    </div> -->
    <!-- <div class="iknowBtn" @click="goback()">我知道了</div> -->
  </div>
</template>
<script>
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        name:'',
        type:0,
        img:{
          approve: require('../../../assets/img/lexus/member/approceing.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      var params={
        event_code: '审核',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/CarAudit.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      // goback(){
      //   if(this.type==1){
      //     this.$router.replace({name:"LexusMyCars"});
      //     // var params={
      //     //   url:this.weburl+'/lexus/my/cars',
      //     //   isReturn: false 
      //     // }
      //     // this.$appService.openWebView(params)
      //   }
      // }
    }
  }
</script>

<style lang="scss">
.cars{
  position: absolute;
  height: 100%;
  width: 100%;
  background: #f1f1f1;
  .mt-25{
    margin-top: 25px;
  }
  .approve-box{
    margin-top: 40%;
    
    .approve{
      width: 36px;
      height: 48px;
      margin-bottom: 20px;
    }
  }
  .gift_box{
    display: flex;
    margin: 0 15px;
    padding: 10px 15px;
    align-items: center;
    background-color:#fff;
    border-bottom:0.5px solid rgba(0,0,0,.1);
    .gift_title{
      flex: 1;
    }
    .getBtn{
      float: right;
      color: #fff;
      font-size:12px;
      padding:5px 15px;
      border-color: #605C6B;
      background-color:#605C6B;
    }
  }
  .iknowBtn{
    color: #fff;
    font-size:12px;
    text-align: center;
    padding:12px 25px;
    margin: 25px 30%;
    border-color: #605C6B;
    background-color:#605C6B;
  }

}
</style>
